var chunkMapping = {
	"0": [
		4645
	],
	"76": [
		5050
	],
	"152": [
		5126
	],
	"153": [
		5127
	],
	"156": [
		5130
	],
	"157": [
		5131
	],
	"158": [
		5132
	],
	"159": [
		5133
	],
	"160": [
		5134
	],
	"161": [
		5135
	],
	"162": [
		5136
	],
	"163": [
		5137
	],
	"164": [
		5138
	],
	"165": [
		5139
	],
	"166": [
		5140
	],
	"167": [
		5141
	],
	"168": [
		5142
	],
	"169": [
		5143
	],
	"170": [
		5144
	],
	"171": [
		5145
	],
	"172": [
		5146
	]
};
var idToExternalAndNameMapping = {
	"4645": [
		"default",
		"./Containers",
		3800
	],
	"5050": [
		"default",
		"./OrderlessInvoices",
		3800
	],
	"5126": [
		"default",
		"./AsyncEventTracker",
		3800
	],
	"5127": [
		"default",
		"./HostWrapper",
		3800
	],
	"5130": [
		"default",
		"./CheckoutV3",
		3800
	],
	"5131": [
		"default",
		"./CheckoutConfirmation",
		3800
	],
	"5132": [
		"default",
		"./ContactCreditCards",
		3800
	],
	"5133": [
		"default",
		"./AuditDialog",
		3800
	],
	"5134": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3800
	],
	"5135": [
		"default",
		"./InvoiceDialog",
		3800
	],
	"5136": [
		"default",
		"./PaymentDueModal",
		3800
	],
	"5137": [
		"default",
		"./PaymentModal",
		3800
	],
	"5138": [
		"default",
		"./PaymentHistory",
		3800
	],
	"5139": [
		"default",
		"./PaymentConfigurations",
		3800
	],
	"5140": [
		"default",
		"./PaymentPreferences",
		3800
	],
	"5141": [
		"default",
		"./ManagePaymentProcessing",
		3800
	],
	"5142": [
		"default",
		"./MobilePaymentsWrapper",
		3800
	],
	"5143": [
		"default",
		"./Challenge",
		3800
	],
	"5144": [
		"default",
		"./ManagePaymentMethods",
		3800
	],
	"5145": [
		"default",
		"./LightspeedReports",
		3800
	],
	"5146": [
		"default",
		"./ShippingPromotionsListContainer",
		3800
	]
};
var idToRemoteMap = {
	"4645": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5050": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5126": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5127": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5130": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5132": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5133": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5134": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5142": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5143": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5144": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5145": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	],
	"5146": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3800
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}